import { applyMiddleware, createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import { composeWithDevTools } from "@redux-devtools/extension";
import { rootReducer } from "./root-reducer";
import rootSaga from "./rootSaga";

const sagaMiddleware = createSagaMiddleware();
const middlewares = [sagaMiddleware];
const middlewareEnhancer = applyMiddleware(...middlewares);
const composeEnhancers = composeWithDevTools({
  name: "RedGifs",
});

const store = createStore(
  rootReducer,
  composeEnhancers(middlewareEnhancer)
);
sagaMiddleware.run(rootSaga);

export { store };
